import React from "react";

export default function SalesPages({
    page, nav, isA, isDB, user, lang, T, C, fmt, today, todayStr,
  monthStart, monthEnd, fyStart, fyEnd, last7, last30, filterByDate,
  getFYList, gCalc, dlCSV, numToWords,
  canAccess, getPlanLimit, tenantPlan,
  companies, setCompanies, custs, setCusts, supps, setSupps,
  prods, setProds, orders, setOrders, pays, setPays,
  purs, setPurs, notes, setNotes, users, setUsers,
  beats, setBeats, expenses, setExpenses, cheques, setCheques,
  modal, setModal, form, setForm,
  payOid, setPayOid, nItems, setNItems,
  payAmt, setPayAmt, payMethod2, setPayMethod2,
  payingCust, setPayingCust, dbOtp, setDbOtp,
  dbOtpOrderId, setDbOtpOrderId,
  dateFrom, setDateFrom, dateTo, setDateTo,
  gTab, setGTab, selFY, setSelFY, cf, setCf, prev, setPrev,
  aiInsight, aiLoading, aiPurSug, setAiPurSug,
  myCompany, setMyCompany, editMyComp, setEditMyComp,
  fOrders, fPays, fPurs, lowS, tSales, tPaid, tDue,
  loadData, showToast, handleOrder, handlePur, addPay, setSubPage, subPage,
  getAIInsights, getSmartPurchaseSuggestions,
  sendDailyReport, sendPaymentReminder, gc, API,
  accounts, setAccounts,
  srch, setSrch, oTab, setOTab, oPage, setOPage, payForm, setPayForm,
  pInv, pPur, pNote, pReceipt, waShare,
  Bdg, CB, Card, Sc, Row, Btn, Inp, Sel, Bar, Modal,
  AddProdToInvoice, InvModal, BankRecon, PhotoScanModal,
  NC, NI, SC, CC, editC, editComp, setEditComp,
  UnivFilter, CFbar
}){
  return(<>

          {page==="orders"&&<div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>📦 Orders ({orders.length})</div>
              <Btn ch="+ New Order" oc={()=>setSubPage("newOrder")} color={C.primary}/>
            </div>
            {isA&&<CFbar/>}
            <UnivFilter placeholder="🔍 Customer, invoice no..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            {(()=>{
              const allO=orders.filter(o=>(cf==="all"||o.cid===cf)&&(!dateFrom||o.date>=dateFrom)&&(!dateTo||o.date<=dateTo)&&(!srch||o.cust?.toLowerCase().includes(srch.toLowerCase())||o.inv?.toLowerCase().includes(srch.toLowerCase())||o.items?.some(it=>(it.product_name||it.name||"").toLowerCase().includes(srch.toLowerCase()))));
              const tabs=[
                {key:"active",label:"🔴 Active",statuses:["Pending","Processing","Dispatched"],color:"#DC2626"},
                {key:"delivered",label:"✅ Delivered",statuses:["Delivered"],color:"#16A34A"},
                {key:"paid",label:"💰 Paid",statuses:["Paid"],color:"#2563EB"},
                {key:"all",label:"📋 All",statuses:null,color:"#64748B"},
              ];
              const filtered=oTab==="all"?allO:allO.filter(o=>tabs.find(t=>t.key===oTab)?.statuses?.includes(o.status));
              const PAGE_SIZE=50;
              const totalPages=Math.ceil(filtered.length/PAGE_SIZE);
              const pageOrders=oTab==="active"?filtered.slice():filtered.slice().slice(oPage*PAGE_SIZE,(oPage+1)*PAGE_SIZE);
              return <>
                <div style={{display:"flex",gap:6,marginBottom:10,overflowX:"auto",paddingBottom:4}}>
                  {tabs.map(t=>{
                    const cnt=t.statuses?allO.filter(o=>t.statuses.includes(o.status)).length:allO.length;
                    return <button key={t.key} onClick={()=>{setOTab(t.key);setOPage(0);}} style={{padding:"6px 12px",borderRadius:20,border:`1.5px solid ${t.color}`,background:oTab===t.key?t.color:"transparent",color:oTab===t.key?"#fff":t.color,cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:11,whiteSpace:"nowrap",flexShrink:0}}>{t.label} ({cnt})</button>;
                  })}
                </div>
                {oTab!=="active"&&totalPages>1&&<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,padding:"6px 10px",background:"#F8FAFC",borderRadius:8,fontSize:11}}>
                  <span style={{color:"#64748B"}}>{filtered.length} • Page {oPage+1}/{totalPages}</span>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    <button onClick={()=>setOPage(p=>Math.max(0,p-1))} disabled={oPage===0} style={{padding:"4px 12px",borderRadius:6,border:"1px solid #E2E8F0",background:oPage===0?"#F1F5F9":"#fff",cursor:oPage===0?"not-allowed":"pointer",fontSize:11}}>← Prev</button>
                    <button onClick={()=>setOPage(p=>Math.min(totalPages-1,p+1))} disabled={oPage>=totalPages-1} style={{padding:"4px 12px",borderRadius:6,border:"1px solid #E2E8F0",background:oPage>=totalPages-1?"#F1F5F9":"#fff",cursor:oPage>=totalPages-1?"not-allowed":"pointer",fontSize:11}}>Next →</button>
                  </div>
                </div>}
                {filtered.length===0&&<div style={{textAlign:"center",padding:20,color:"#94A3B8"}}>{oTab==="active"?"🎉 All clear!":"No orders found."}</div>}
              {pageOrders.map(o=>{
              const co=gc(o.cid);const due=o.total-(o.paid||0);
              return <Card key={o.id} style={{marginBottom:8,borderLeft:`3px solid ${co?.color||C.primary}`}}>
                <div onClick={()=>setPrev(o)} style={{cursor:"pointer",marginBottom:6}}>
                  <div style={{display:"flex",justifyContent:"space-between"}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:6}}><CB co={co}/><span style={{fontWeight:700,fontSize:13}}>{o.cust}</span></div>
                      <div style={{fontSize:10,color:C.sub}}>{o.inv} • {(o.date||"").slice(0,10)} • by {o.by||o.added_by||"—"}</div>
                      <div style={{fontSize:10,color:C.sub}}>{o.items?.slice(0,2).map(i=>`${i.product_name||i.name||""}(×${i.qty})`).join(", ")}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontWeight:800,fontSize:13,color:co?.color||C.primary}}>₹{fmt(o.total)}</div>
                      <Bdg l={o.status} c={SC[o.status]}/>
                      <div style={{fontSize:9,color:C.info,marginTop:2}}>👁️ Tap to view invoice</div>
                    </div>
                  </div>
                </div>
                <Bar v={o.paid||0} max={o.total} c={due===0?C.success:C.warning}/>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:10,marginTop:3,marginBottom:7}}>
                  <span style={{color:C.success}}>Paid: ₹{fmt(o.paid||0)}</span>
                  <span style={{color:due>0?C.danger:C.success}}>{due>0?`Due: ₹${fmt(due)}`:"✓ Paid"}</span>
                </div>
                <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                  {isA?["Pending","Processing","Dispatched","Delivered"].map(s=><button key={s} onClick={async()=>{
                    if(s==="Dispatched"){
                      // Generate OTP and send to customer
                      const otp=Math.floor(100000+Math.random()*900000).toString();
                      try{
                        await API.post(`/orders/${o.id}/dispatch`,{otp});
                        // WhatsApp OTP to customer
                        const phone=(o.customer_phone||o.cust_phone||"").replace(/[^0-9]/g,"");
                        if(phone){
                          const msg=encodeURIComponent(`🚚 *Delivery OTP*\n\nDear ${o.customer_name||o.cust||""},\n\nYour order *${o.inv||o.invoice_no||o.id}* has been dispatched.\n\n🔑 *Delivery OTP: ${otp}*\n\nPlease share this OTP with the delivery person on arrival.\n\n🏢 ${myCompany?.name||"DawnToDusk Pro"}`);
                          window.open(`https://wa.me/91${phone}?text=${msg}`,"_blank");
                        }
                        setOrders(orders.map(x=>x.id===o.id?{...x,status:"Dispatched"}:x));
                        showToast("✅ Dispatched! OTP sent to customer!");
                        await loadData(true);
                      }catch(e){showToast("❌ Error: "+e.message,"err");}
                    } else {
                      setOrders(orders.map(x=>x.id===o.id?{...x,status:s}:x));
                      try{await API.updateStatus(o.id,s);await loadData(true);}catch(e){console.log(e);}
                      showToast(`${s} ✓`);
                    }
                  }} style={{fontSize:10,padding:"3px 8px",borderRadius:6,border:`1.5px solid ${SC[s]||C.info}`,background:o.status===s?SC[s]||C.info:"transparent",color:o.status===s?"#fff":SC[s]||C.info,cursor:"pointer",fontWeight:600}}>{s==="Dispatched"?"🚚 Dispatch":s}</button>):<Bdg l={o.status} c={SC[o.status]}/>}
                  {due>0&&<Btn ch="💰 Pay" oc={()=>{
                    if(isA){
                      setModal("pay");setForm({cust:o.cust,amt:due,method:"Cash"});setPayOid(o.id);
                    } else {
                      setPayingCust(o.cust);setPayAmt(String(due));
                      nav("staff_pays");
                    }
                  }} color={C.success} sm/>}
                  <Btn ch="📲 WA" oc={()=>waShare(o,co)} color="#25D366" sm/>
                  {isA&&<Btn ch="🖨️ Print" oc={()=>pInv(o,co,myCompany)} color={co?.color||C.primary} out sm/>}
                  {isA&&(o.total-(o.paid||0))>0&&<Btn ch="🔔 Remind" oc={async()=>{
                    const res=await API.sendReminder({
                      to:o.email||"",customerName:o.cust,invoiceNo:o.inv,
                      amount:fmt(o.total-(o.paid||0)),dueDate:"",
                      firmName:myCompany?.name||"",firmPhone:myCompany?.phone||""
                    });
                    if(res?.whatsapp){window.open(res.whatsapp,"_blank");}
                    else{showToast("✅ Reminder sent!");}
                  }} color={"#F59E0B"} out sm/>}
                  {isA&&o.status==="Delivered"&&<Btn ch="📗 CR" oc={()=>{setModal("note");setForm({nt:"Credit Note",cid:o.cid,party:o.cust,refInv:o.inv,gt:o.gt||"CGST_SGST"});setNItems([]);}} color={NC["Credit Note"]} out sm/>}
                  {isA&&o.status==="Delivered"&&<Btn ch="↩️ Ret" oc={()=>{setModal("note");setForm({nt:"Sale Return",cid:o.cid,party:o.cust,refInv:o.inv,gt:o.gt||"CGST_SGST"});setNItems([]);}} color={NC["Sale Return"]} out sm/>}
                  {isA&&<Btn ch="🗑️" oc={async()=>{if(window.confirm(`Delete order ${o.inv}? Stock will not be restored!`)){setOrders(orders.filter(x=>x.id!==o.id));try{await API.deleteOrder(o.id);}catch(e){console.log(e);}await loadData(true);showToast("Order deleted!");}}} color={C.danger} out sm/>}
                </div>
              </Card>;
            })}
              </>;
            })()}
          </div>}

          {/* ADMIN PAYMENTS */}
          {page==="pays"&&isA&&<div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>💰 Payments</div>
              <Btn ch="+ Record" oc={()=>{setModal("pay");setForm({method:"Cash"});setPayOid("");}}/>
            </div>
            <UnivFilter placeholder="🔍 Customer / Invoice..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>

            {/* Summary Cards */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(100px,1fr))",gap:8,marginBottom:12}}>
              <Sc icon="✅" label="Collected" value={`₹${fmt(pays.reduce((s,p)=>s+(+p.amt||0),0))}`} color={C.success}/>
              <Sc icon="⏳" label="Total Due" value={`₹${fmt(custs.reduce((s,c)=>s+(+c.bal||0),0))}`} color={C.danger}/>
              <Sc icon="👥" label="Due Customers" value={custs.filter(c=>(c.bal||0)>0).length} color={C.warning}/>
            </div>

            {/* Outstanding Customers — ALL */}
            <Card style={{marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <div style={{fontSize:13,fontWeight:700}}>🔴 Outstanding Due — All Customers</div>
                <div style={{fontSize:11,color:C.sub}}>High → Low</div>
              </div>

              {/* Search */}
              <input
                placeholder="🔍 Customer search..."
                onChange={e=>setCf(e.target.value||"all")}
                style={{width:"100%",padding:"8px 12px",borderRadius:9,border:`1.5px solid ${C.border}`,fontSize:12,background:"#F8FAFC",outline:"none",boxSizing:"border-box",marginBottom:10,fontFamily:"inherit"}}
              />

              {/* All customers with due — sorted high to low */}
              {custs
                .filter(c=>(c.bal||0)>0)
                .filter(c=>cf==="all"||!cf||c.name?.toLowerCase().includes(cf.toLowerCase())||c.phone?.includes(cf))
                .sort((a,b)=>(b.bal||0)-(a.bal||0))
                .map(c=>{
                  const custOrders=orders.filter(o=>o.cust===c.name&&(o.total-(o.paid||0))>0);
                  const lastOrder=orders.filter(o=>o.cust===c.name).sort((a,b)=>new Date(b.date)-new Date(a.date))[0];
                  const daysSince=lastOrder?Math.ceil((new Date()-new Date(lastOrder.date))/(864e5)):0;
                  return(
                    <div key={c.id} style={{padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                        <div style={{flex:1}}>
                          <div style={{fontWeight:700,fontSize:13}}>{c.name}</div>
                          <div style={{fontSize:10,color:C.sub}}>📞 {c.phone||"—"} • 📍 {c.city||"—"}</div>
                          {lastOrder&&<div style={{fontSize:10,color:daysSince>30?C.danger:C.sub,marginTop:2}}>
                            🕐 Last order: {daysSince} days ago ({lastOrder.date})
                          </div>}
                          {custOrders.length>0&&<div style={{fontSize:10,color:C.warning,marginTop:1}}>
                            📦 {custOrders.length} pending invoice{custOrders.length>1?"s":""}
                          </div>}
                        </div>
                        <div style={{textAlign:"right",marginLeft:8}}>
                          <div style={{fontSize:16,fontWeight:800,color:(c.bal||0)>10000?C.danger:C.warning}}>₹{fmt(c.bal)}</div>
                          <div style={{fontSize:9,color:C.sub}}>Pending Due</div>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        <button onClick={()=>{setModal("pay");setForm({cust:c.name,method:"Cash"});setPayOid("");}} style={{flex:2,padding:"7px",borderRadius:8,background:C.success,border:"none",color:"#fff",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"inherit"}}>
                          💰 Payment Collect
                        </button>
                        <button onClick={()=>sendPaymentReminder(c)} style={{flex:1,padding:"7px",borderRadius:8,background:"#25D366",border:"none",color:"#fff",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"inherit"}}>
                          📱 Reminder
                        </button>
                        <button onClick={()=>{
                          const msg=orders.filter(o=>o.cust===c.name&&(o.total-(o.paid||0))>0).map(o=>`${o.inv}: ₹${fmt(o.total-(o.paid||0))}`).join("\n");
                          alert(`${c.name} — pending invoices:\n\n${msg||"No pending invoices"}`);
                        }} style={{padding:"7px 10px",borderRadius:8,background:C.info,border:"none",color:"#fff",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"inherit"}}>
                          👁️
                        </button>
                      </div>
                    </div>
                  );
                })}
              {custs.filter(c=>(c.bal||0)>0).length===0&&
                <div style={{textAlign:"center",padding:20,color:C.sub,fontSize:12}}>✅ No outstanding dues!</div>}
            </Card>

            {/* Payment History */}

            {/* Staff Filter Chips */}
            {(()=>{
              const staffList=[...new Set(pays.filter(p=>p.by||p.added_by).map(p=>p.by||p.added_by))];
              if(!staffList.length) return null;
              return<div style={{marginBottom:8}}>
                <div style={{fontSize:10,color:C.sub,fontWeight:700,marginBottom:5}}>👤 Staff Filter:</div>
                <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                  <button onClick={()=>{setDateFrom(todayStr());setDateTo(todayStr());setSrch("");}}
                    style={{padding:"5px 10px",borderRadius:20,border:`1.5px solid ${dateFrom===todayStr()&&dateTo===todayStr()?"#16A34A":C.border}`,background:dateFrom===todayStr()&&dateTo===todayStr()?"#16A34A":"#fff",color:dateFrom===todayStr()&&dateTo===todayStr()?"#fff":C.text,fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
                    📅 Today
                  </button>
                  <button onClick={()=>{setDateFrom("");setDateTo("");setSrch("");}}
                    style={{padding:"5px 10px",borderRadius:20,border:`1.5px solid ${!dateFrom&&!dateTo&&!srch?C.primary:C.border}`,background:!dateFrom&&!dateTo&&!srch?C.primary:"#fff",color:!dateFrom&&!dateTo&&!srch?"#fff":C.text,fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>
                    All
                  </button>
                  {staffList.map(s=>{
                    const isActive=srch===s;
                    const todayAmt=pays.filter(p=>(p.by||p.added_by)===s&&(p.date||"").slice(0,10)===todayStr()).reduce((t,p)=>t+(+p.amt||0),0);
                    return<button key={s} onClick={()=>setSrch(isActive?"":s)}
                      style={{padding:"5px 11px",borderRadius:20,border:`1.5px solid ${isActive?C.primary:C.border}`,background:isActive?C.primary+"20":"#fff",fontSize:11,cursor:"pointer",fontFamily:"inherit",fontWeight:isActive?700:400}}>
                      👤 {s}{todayAmt>0?' ₹'+fmt(todayAmt):''}
                    </button>;
                  })}
                </div>
              </div>;
            })()}

            <Card>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontSize:12,fontWeight:700}}>📋 Payment History</div>
                <Btn ch="⬇️ CSV" oc={()=>dlCSV("payments.csv",
                  ["Date","Customer","Amount","Method","Invoice","By"],
                  pays.map(p=>[p.date,p.cust,p.amt,p.method||"Cash",p.inv||"",p.by||""])
                )} color={C.primary} sm out/>
              </div>
              {(()=>{
              const fList=pays.filter(p=>
                (!dateFrom||p.date>=dateFrom)&&
                (!dateTo||p.date<=dateTo)&&
                (cf==="all"||String(p.cid||"")===String(cf||""))&&
                (!srch||p.cust?.toLowerCase().includes(srch.toLowerCase())||
                  p.inv?.toLowerCase().includes(srch.toLowerCase())||
                  (p.by||p.added_by||"").toLowerCase().includes(srch.toLowerCase()))
              );
              return<>
              {fList.slice(0,100).map(p=>{
                const co=gc(p.cid);
                return(
                  <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:`1px solid ${C.border}`}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:5}}>
                        {co&&<CB co={co}/>}
                        <span style={{fontSize:12,fontWeight:600}}>{p.cust}</span>
                      </div>
                      <div style={{fontSize:9,color:C.sub}}>{p.inv||"—"} • {p.date} • {p.method||"Cash"}{(p.by||p.added_by)&&<span style={{color:C.info}}> • 👤{p.by||p.added_by}</span>}</div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:7}}>
                      <div style={{fontSize:12,fontWeight:700,color:C.success}}>+₹{fmt(p.amt)}</div>
                      <Btn ch="🧾 Receipt" oc={()=>pReceipt({id:p.id,cust:p.cust,amt:p.amt,method:p.method||"Cash",date:p.date,inv:p.inv||"",note:p.note||""},myCompany)} color={C.primary} sm out/>
                      {isA&&<button onClick={async()=>{
                        if(window.confirm(`Delete payment of ₹${fmt(p.amt)}?`)){
                          setPays(pays.filter(x=>x.id!==p.id));
                          setCusts(custs.map(c=>c.name===p.cust?{...c,bal:(c.bal||0)+(+p.amt),paid:Math.max(0,(c.paid||0)-(+p.amt))}:c));
                          try{await API.deletePayment(p.id);}catch(e){console.log(e);}
                          await loadData(true);showToast("Payment deleted!");
                        }
                      }} style={{background:"transparent",border:`1px solid ${C.danger}`,color:C.danger,padding:"2px 7px",borderRadius:6,cursor:"pointer",fontSize:10,fontFamily:"inherit"}}>🗑️</button>}
                    </div>
                  </div>
                );
              })}
              {pays.length===0&&<div style={{textAlign:"center",color:C.sub,fontSize:12,padding:10}}>No payments yet</div>}</>;
            })()}
            </Card>
          </div>}

          {/* STAFF PAYMENT COLLECTION — New dedicated page */}
          {page==="staff_pays"&&!isA&&<div>
            <div style={{fontSize:17,fontWeight:800,marginBottom:6}}>💰 Payment Collection</div>
            <div style={{fontSize:12,color:C.sub,marginBottom:12}}>Tap a customer's name below to record a payment</div>
            {/* Due customers list - only my customers or beat-assigned */}
            {(()=>{
              const todayDayName=new Date().toLocaleDateString("en-US",{weekday:"long"});
              const myBeatCusts=beats.filter(b=>b.day===todayDayName&&(b.staff||[]).includes(user?.name)).flatMap(b=>b.customers||[]);
              const myCusts=custs.filter(c=>(c.bal||0)>0&&(c.by===user?.username||c.added_by===user?.username||myBeatCusts.includes(c.name)));
              if(myCusts.length===0) return <Card><div style={{textAlign:"center",padding:20,color:C.sub}}>✅ No outstanding dues right now!</div></Card>;
              return myCusts.map(c=>(
              <Card key={c.id} style={{marginBottom:10,borderLeft:`4px solid ${C.danger}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:14,color:C.text}}>{c.name}</div>
                    <div style={{fontSize:11,color:C.sub}}>📞{c.phone} • 📍{c.city}</div>
                    {c.gstin&&<div style={{fontSize:10,color:C.info}}>GSTIN: {c.gstin}</div>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:18,fontWeight:800,color:C.danger}}>₹{fmt(c.bal)}</div>
                    <div style={{fontSize:10,color:C.sub}}>Outstanding</div>
                  </div>
                </div>
                {/* Orders due for this customer */}
                {orders.filter(o=>o.cust===c.name&&(o.total-(o.paid||0))>0).map(o=>{
                  const co=gc(o.cid);const due=o.total-(o.paid||0);
                  return <div key={o.id} style={{background:C.bg,borderRadius:8,padding:"8px 10px",marginBottom:6,border:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div><CB co={co}/><span style={{fontSize:11,fontWeight:600,marginLeft:5}}>{o.inv} • {(o.date||"").slice(0,10)}</span></div>
                      <div style={{textAlign:"right"}}><span style={{fontSize:12,fontWeight:700,color:C.danger}}>Due: ₹{fmt(due)}</span></div>
                    </div>
                  </div>;
                })}
                {/* Quick payment entry */}
                {payingCust===c.name?(
                  <div style={{background:"#F0FDF4",borderRadius:9,padding:"12px",border:`1.5px solid ${C.success}`}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.success,marginBottom:9}}>✅ Enter Payment</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
                      <div>
                        <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:4}}>Amount ₹</div>
                        <input type="number" value={payAmt} onChange={e=>setPayAmt(e.target.value)} placeholder="Amount..." style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1.5px solid ${C.success}`,fontSize:14,fontWeight:700,color:C.success,outline:"none",boxSizing:"border-box"}}/>
                      </div>
                      <div>
                        <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:4}}>Method</div>
                        <select value={payMethod2} onChange={e=>setPayMethod2(e.target.value)} style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1.5px solid ${C.border}`,fontSize:13,background:"#F8FAFC",outline:"none",fontFamily:"inherit"}}>
                          {["Cash","UPI","Bank Transfer","Cheque","NEFT/RTGS"].map(m=><option key={m}>{m}</option>)}
                        </select>
                      </div>
                    </div>
                    {(accounts||[]).length>0&&<div style={{marginBottom:8}}>
                      <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:4}}>Account — kaunse account mein gaya?</div>
                      <select value={form.payAccountId||""} onChange={e=>setForm({...form,payAccountId:e.target.value})} style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1.5px solid ${C.border}`,fontSize:13,background:"#F8FAFC",outline:"none",fontFamily:"inherit"}}>
                        <option value="">-- Account (default: Cash) --</option>
                        {accounts.map(a=><option key={a.id} value={a.id}>{a.type==="cash"?"💵":"🏦"} {a.name}</option>)}
                      </select>
                    </div>}
                    <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                      <Btn ch={`✅ Save ₹${payAmt||0} Payment`} oc={()=>{if(!payAmt||+payAmt<=0)return;addPay(c.name,payAmt,payMethod2,null,form.payAccountId||null);setPayingCust(null);setPayAmt("");setPayMethod2("Cash");setForm({...form,payAccountId:""});}} color={C.success} s={{flex:1}}/>
                      <Btn ch="✕ Cancel" oc={()=>{setPayingCust(null);setPayAmt("");}} color={C.sub} out s={{flex:1}}/>
                    </div>
                  </div>
                ):(
                  <Btn ch={`💰 Receive Payment — ₹${fmt(c.bal)} Due`} oc={()=>{setPayingCust(c.name);setPayAmt(String(c.bal));setPayMethod2("Cash");}} color={C.success} s={{width:"100%",justifyContent:"center",marginTop:4}}/>
                )}
              </Card>
            ));
            })()}
            {/* Recent payments by this staff */}
            {pays.filter(p=>(p.by||p.added_by)===user.username).length>0&&<Card style={{marginTop:14}}>
              <div style={{fontSize:12,fontWeight:700,marginBottom:8}}>📋 My Collections So Far</div>
              {pays.filter(p=>(p.by||p.added_by)===user.username).slice(0,10).map(p=><div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:`1px solid ${C.border}`}}>
                <div><div style={{fontSize:12,fontWeight:600}}>{p.cust}</div><div style={{fontSize:9,color:C.sub}}>{p.date} • {p.method}</div></div>
                <div style={{fontSize:12,fontWeight:700,color:C.success}}>+₹{fmt(p.amt)}</div>
              </div>)}
              <div style={{marginTop:8,fontSize:12,fontWeight:700,color:C.success,textAlign:"right"}}>
                Total: ₹{fmt(pays.filter(p=>(p.by||p.added_by)===user.username).reduce((s,p)=>s+p.amt,0))}
              </div>
            </Card>}
          </div>}

          {/* INVOICE */}
          {page==="inv"&&isA&&<div>
            <UnivFilter placeholder="🔍 Invoice no, customer..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>🧾 Invoices</div>
              <Btn ch="⬇️ CSV" oc={()=>dlCSV("invoices.csv",
                ["Invoice","Customer","Date","Total","Paid","Due","Status"],
                orders.filter(o=>(cf==="all"||o.cid===cf)).map(o=>[o.inv||o.id,o.cust,o.date,o.total,o.paid||0,(+o.total-(+o.paid||0)),o.status])
              )} color={C.primary} sm out/>
            </div>
            {(()=>{
              const fInv=orders.filter(o=>
                (cf==="all"||String(o.cid||"")===String(cf||""))&&
                (!dateFrom||o.date>=dateFrom)&&
                (!dateTo||o.date<=dateTo)&&
                (!srch||o.cust?.toLowerCase().includes(srch.toLowerCase())||
                  o.inv?.toLowerCase().includes(srch.toLowerCase())||
                  o.items?.some(it=>(it.product_name||it.name||"").toLowerCase().includes(srch.toLowerCase())))
              );
              return<>
                {fInv.length===0&&<Card><div style={{textAlign:"center",padding:20,color:C.sub}}>No invoices found</div></Card>}
                {fInv.slice(0,100).map(o=>{
                  const co=gc(o.cid);
                  const due=(+o.total||0)-(+o.paid||0);
                  return<Card key={o.id} style={{marginBottom:8,borderLeft:`3px solid ${co?.color||C.primary}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                          <CB co={co}/>
                          <span style={{fontWeight:700,fontSize:13}}>{o.cust}</span>
                        </div>
                        <div style={{fontSize:10,color:C.sub}}>{o.inv||o.id} • {o.date}</div>
                        <div style={{fontSize:10,color:C.sub,marginTop:1}}>
                          {o.items?.slice(0,2).map(i=>`${i.product_name||i.name||""}(×${i.qty})`).join(", ")}
                          {(o.items?.length||0)>2?` +${o.items.length-2} more`:""}
                        </div>
                      </div>
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontWeight:800,fontSize:15,color:co?.color||C.primary}}>₹{fmt(o.total)}</div>
                        <Bdg l={o.status} c={SC[o.status]}/>
                        {due>0&&<div style={{fontSize:10,color:C.danger,fontWeight:700}}>Due: ₹{fmt(due)}</div>}
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <Btn ch="🖨️ Print" oc={e=>{e.stopPropagation();pInv(o,co,myCompany);}} color={C.primary} sm out/>
                      <Btn ch="✏️ Edit" oc={e=>{e.stopPropagation();setPrev(o);}} color={C.info} sm out/>
                      <Btn ch="💰 Pay" oc={e=>{e.stopPropagation();setModal("pay");setForm({cust:o.cust,amt:due,method:"Cash"});setPayOid(o.id);}} color={C.success} sm out style={{display:due>0?"flex":"none"}}/>
                    </div>
                  </Card>;
                })}
              </>;
            })()}
          </div>}

          {/* ADMIN NOTES */}
          {page==="notes"&&isA&&<div>
            <UnivFilter srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:17,fontWeight:800}}>📋 Credit / Debit Notes</div>
              <Btn ch="+ Create Note" oc={()=>{setModal("note");setForm({gt:"CGST_SGST"});setNItems([]);}}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:12}}>
              {[{t:"Credit Note",i:"📗",c:C.success},{t:"Debit Note",i:"📕",c:C.danger},{t:"Sale Return",i:"↩️",c:C.warning},{t:"Purchase Return",i:"↪️",c:C.purple}].map(s=><Card key={s.t} style={{borderLeft:`3px solid ${s.c}`,padding:"10px 12px"}}>
                <div style={{fontSize:11,fontWeight:700,color:s.c}}>{s.i} {s.t}</div>
                <div style={{fontSize:15,fontWeight:800,color:C.text,marginTop:3}}>{notes.filter(n=>n.type===s.t).length}</div>
                <div style={{fontSize:10,color:C.sub}}>₹{fmt(notes.filter(n=>n.type===s.t).reduce((x,n)=>x+n.total,0))}</div>
              </Card>)}
            </div>
            {notes.map(note=>{const co=gc(note.cid);const nc=NC[note.type]||C.primary;return <Card key={note.id} style={{marginBottom:7,borderLeft:`4px solid ${nc}`}}>
              <div style={{display:"flex",justifyContent:"space-between"}}>
                <div><div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}><CB co={co}/><span style={{fontSize:11,fontWeight:700,color:nc}}>{NI[note.type]} {note.type}</span></div>
                  <div style={{fontWeight:700,fontSize:12}}>{note.note_no||note.noteNo}</div>
                  <div style={{fontSize:10,color:C.sub}}>{note.party} • {(note.date||"").slice(0,10)} • {note.reason}</div>
                  {note.refInv&&<div style={{fontSize:9,color:C.sub}}>Ref: {note.refInv}</div>}
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontWeight:800,color:nc}}>₹{fmt(+note.total||0)}</div>
                  <Bdg l={note.status||"Approved"} c={C.success}/>
                  {isA&&<div style={{marginTop:5}}><Btn ch="🗑️" oc={async()=>{if(window.confirm(`Delete note ${note.note_no||note.noteNo}?`)){setNotes(notes.filter(x=>x.id!==note.id));try{await API.deleteNote(note.id);await loadData(true);showToast("Note deleted!");}catch(e){setNotes(notes);showToast("❌ Delete failed: "+(e.message||"Server error"),"err");}}}} color={C.danger} out sm/></div>}
                </div>
              </div>
            </Card>;})}
            {notes.length===0&&<Card><div style={{textAlign:"center",padding:20,color:C.sub}}>No notes yet. Use "+ Create Note" to add one.</div></Card>}
          </div>}

          {/* PURCHASES */}
          {page==="purs"&&isA&&<div>
            <UnivFilter srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>🛒 Purchase Bills ({purs.length})</div>
              <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                {canAccess("photoscan")&&<Btn ch="📸 Photo Scan" oc={()=>setModal("photoScan")} color={C.warning}/>}
                <Btn ch="+ New Purchase" oc={()=>setSubPage("newPur")} color={C.info}/>
              </div>
            </div>
            <CFbar/>
            {(()=>{
              const fList=purs.filter(p=>(cf==="all"||p.cid===cf)&&(!srch||p.supp?.toLowerCase().includes(srch.toLowerCase())||p.id?.toLowerCase().includes(srch.toLowerCase())));
              return<>
              {fList.slice(0,50).map(p=>{
              const co=gc(p.cid);const due=p.total-(p.paid||0);
              return <Card key={p.id} style={{marginBottom:8,borderLeft:`3px solid ${co?.color||C.primary}`}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <div><div style={{display:"flex",alignItems:"center",gap:6}}><CB co={co}/><span style={{fontWeight:700,fontSize:12}}>{p.supp}</span></div><div style={{fontSize:10,color:C.sub}}>{p.id} • {p.date}</div></div>
                  <div style={{textAlign:"right"}}><div style={{fontWeight:700,color:C.info}}>₹{fmt(p.total)}</div><Bdg l={p.status} c={SC[p.status]||C.success}/></div>
                </div>
                <div style={{background:C.bg,borderRadius:7,padding:"6px 9px",marginBottom:7}}>
                  {p.items.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:2}}>
                    <span style={{fontWeight:500}}>{it.name}</span>
                    <span style={{color:C.sub}}>HSN:{it.hsn} × {it.qty} @ ₹{it.cp}</span>
                  </div>)}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:10,marginBottom:7}}>
                  <span style={{color:C.success}}>Paid: ₹{fmt(p.paid||0)}</span>
                  <span style={{color:due>0?C.danger:C.success}}>{due>0?`Due: ₹${fmt(due)}`:"✓ Paid"}</span>
                </div>
                <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                  {(+p.total-(+p.paid||0))>0&&<Btn ch="💰 Pay" oc={()=>{setModal("suppPay");setForm({supp:p.supp,pur_id:p.id,amt:Math.max(0,+p.total-(+p.paid||0)),method:"Cash"});}} color={C.success} sm/>}
                  <Btn ch="✏️ Edit" oc={()=>{setModal("editPur");setForm({...p,items:[...(p.items||[])]});}} color={C.primary} out sm/>
                  <Btn ch="↪️ Purchase Return" oc={()=>{setModal("note");setForm({nt:"Purchase Return",cid:p.cid,party:p.supp,gt:"CGST_SGST"});setNItems([]);}} color={NC["Purchase Return"]} out sm/>
                  <Btn ch="📕 Debit Note" oc={()=>{setModal("note");setForm({nt:"Debit Note",cid:p.cid,party:p.supp,gt:"CGST_SGST"});setNItems([]);}} color={NC["Debit Note"]} out sm/>
                  <Btn ch="🗑️" oc={async()=>{if(window.confirm(`Delete purchase ${p.id}?`)){setPurs(purs.filter(x=>x.id!==p.id));try{await API.deletePurchase(p.id);}catch(e){console.log(e);}await loadData(true);showToast("Purchase deleted!");}}} color={C.danger} out sm/>
                </div>
              </Card>;
            })}
              </>;
            })()}
          </div>}

          {/* INVENTORY */}
  </>);
}
